import React from 'react';
import { VoicePreference } from '../../services/cxone-sdk.service';
import { CxoneConnectionProgress } from '../../types';
import { VoicePreferences } from '../settings/VoicePreferences';
import { AgentWidgetGateConnecting } from './AgentWidgetGateConnecting';
import { AgentWidgetGateLoading } from './AgentWidgetGateLoading';
import { AgentWidgetGateSessionConflict } from './AgentWidgetGateSessionConflict';
import { AgentWidgetGateSessionError } from './AgentWidgetGateSessionError';

interface AgentWidgetGateProps {
  isConnecting: boolean;
  connectionProgress: CxoneConnectionProgress | null;
  hasSessionConflict: boolean;
  needsVoicePreference: boolean;
  isSessionInvalid: boolean;
  connectionError: string | null;
  isInitialized: boolean;
  isReconnecting: boolean;
  forceLogoutAndReconnect: () => void;
  clearSessionConflict: () => void;
  initializeWithVoicePreference: (preference: VoicePreference) => Promise<void>;
  reconnect: () => void;
  children: React.ReactNode;
}

export function AgentWidgetGate({
  isConnecting,
  connectionProgress,
  hasSessionConflict,
  needsVoicePreference,
  isSessionInvalid,
  connectionError,
  isInitialized,
  isReconnecting,
  forceLogoutAndReconnect,
  clearSessionConflict,
  initializeWithVoicePreference,
  reconnect,
  children,
}: AgentWidgetGateProps) {
  if (isConnecting) {
    return <AgentWidgetGateConnecting connectionProgress={connectionProgress} />;
  }

  if (hasSessionConflict) {
    return (
      <AgentWidgetGateSessionConflict
        onForceLogout={forceLogoutAndReconnect}
        onCancel={clearSessionConflict}
      />
    );
  }

  if (needsVoicePreference) {
    return (
      <VoicePreferences
        onConnect={initializeWithVoicePreference}
        isConnecting={isConnecting}
        error={connectionError}
      />
    );
  }

  if (isSessionInvalid || connectionError) {
    return (
      <AgentWidgetGateSessionError
        isSessionInvalid={isSessionInvalid}
        connectionError={connectionError}
        isReconnecting={isReconnecting}
        onReconnect={reconnect}
      />
    );
  }

  if (!isInitialized) {
    return <AgentWidgetGateLoading messageKey="agent:loading.initializing" />;
  }

  return <>{children}</>;
}
